<template>
  <div class="section-container">

    <well-cards/>

    <div
        v-if="isCycleDetailsEnabled && !isFdaFriendly"
        class="treatment-filter"
        :class="{ hidden: !cycleDetailsAreVisible }"
    >
      <slide-treatment-filter/>
    </div>
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
import WellCards from './WellCards'
import SlideTreatmentFilter from './SlideTreatmentFilter'

export default {
  name: 'TreatmentPageMainBody',
  components: {SlideTreatmentFilter, WellCards},
  computed: {
    ...mapState({
      cycleDetailsAreVisible: state => state.filter.cycleDetailsAreVisible
    }),
    ...mapGetters({
      isCycleDetailsEnabled: 'common/isCycleDetailsEnabled',
      fertMethodNeedsApproval: 'timelapse/fertMethodNeedsApproval',
      isFdaFriendly: 'common/isFdaFriendly'
    }),
    hasSmthToApprove() {
      return this.isCycleDetailsEnabled && this.fertMethodNeedsApproval
    }
  },
  watch: {
    hasSmthToApprove: {
      handler(newVal) {
        if (newVal) {
          this.$store.commit('filter/setCycleDetailsVisibility', true)
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.section-container {
  position: relative;
  width: 100%;
  height: 100%;
  transition: 1s;
  display: flex;

  .treatment-filter {
    position: absolute;
    right: 0;
    width: 22rem;
    transition: 1s;
  }

  .hidden {
    display: none;
    @media screen and #{$new-break3close} {
      display: none;
    }
  }
}
</style>
